import { render, staticRenderFns } from "./BlockWithLinkEl.vue?vue&type=template&id=85b16022&"
import script from "./BlockWithLinkEl.vue?vue&type=script&lang=ts&"
export * from "./BlockWithLinkEl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports